import * as tslib_1 from "tslib";
import { jsonMember } from "typedjson";
export class PitAgreementTaskResult {
}
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], PitAgreementTaskResult.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitAgreementTaskResult.prototype, "ord", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: true }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTaskResult.prototype, "caption", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitAgreementTaskResult.prototype, "value", void 0);
